import {createContext, useContext} from 'react';
import type {FC, ReactNode} from 'react';

// Gates offline capture in FormFileUploadV2. Only the form-fill create path opts
// in; shared consumers (attachments, docs, device photos) never drain the outbox.
const OfflineCaptureContext = createContext<boolean>(false);

export interface OfflineCaptureProviderProps {
  enabled: boolean;
  children: ReactNode;
}

export const OfflineCaptureProvider: FC<OfflineCaptureProviderProps> = ({
  enabled,
  children,
}) => (
  <OfflineCaptureContext.Provider value={enabled}>
    {children}
  </OfflineCaptureContext.Provider>
);

export const useOfflineCaptureEnabled = (): boolean =>
  useContext(OfflineCaptureContext);
